import { AuthService } from "../../auth/services/auth.service";
import { Access } from '../../profile/profile.models'

export class PermissionService {
  constructor(private authService:AuthService) {}
  hasFullAccess(_entity?: string, _id?: string): boolean {
    if (!this.authService.profile) {
      return false
    }
    return this.authService.profile.userAccess !== Access.Free
  }
}

// export const permissionService = new PermissionService()